module.exports = __webpack_public_path__ + "static/media/cursor-click.c09d61c7.svg";